// Mock data for HuntHeal website

export const COMPANY = {
  brand: "HuntHeal",
  legalName: "prosprotection.store",
  website: "prosprotection.store",
  phone: "+1 877-654-6665",
  phoneRaw: "+18776546665",
  email: "support@prosprotection.store",
  address: {
    line1: "prosprotection.store",
    line2: "Vashi",
    city: "Navi Mumbai",
    state: "Maharashtra",
    zip: "400705",
    country: "India"
  },
  hours: "Mon – Sun, 24/7 Customer Support",
  gstin: "27AAHCD6089J1Z4",
  duns: "861996227"
};

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Features", href: "/#features" },
  { label: "Pricing", href: "/#pricing" },
  { label: "FAQ", href: "/#faq" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" }
];

export const HERO_IMAGES = {
  attack: "https://images.unsplash.com/photo-1614064641938-3bbee52942c7?w=900&auto=format&fit=crop&q=70",
  slow: "https://images.unsplash.com/photo-1694878982190-6e37aa9eb306?w=900&auto=format&fit=crop&q=70",
  happy: "https://images.unsplash.com/photo-1694057336527-fbc3e7c84890?w=900&auto=format&fit=crop&q=70",
  shield: "https://images.unsplash.com/photo-1603985529862-9e12198c9a60?w=900&auto=format&fit=crop&q=70"
};

export const FEATURES = [
  { title: "Automatic Background Scans", desc: "Runs silently in the background without interrupting your daily activities. Set it and forget it protection." },
  { title: "Minimal Performance Impact", desc: "Uses less than 2% of your device's resources. Your phone stays fast and responsive." },
  { title: "Easy-to-Understand Alerts", desc: "Clear, actionable notifications that tell you exactly what's happening and what to do next." },
  { title: "100% Privacy Protection", desc: "No data collection. Your personal information stays on your device and never leaves your control." },
  { title: "Advanced Threat Detection", desc: "AI-powered scanning that detects and blocks the latest malware, spyware, and phishing attempts in real-time." },
  { title: "Smart App Monitoring", desc: "Continuously monitors app behavior and network activity to prevent data leaks and unauthorized access." }
];

export const BENEFITS = [
  {
    title: "All-Day Protection",
    desc: "Continuous monitoring and automatic scans run 24/7 to keep your device protected without any manual intervention.",
    points: ["Real-time threat detection", "Automatic scan scheduling", "Instant threat removal"]
  },
  {
    title: "Lightweight & Fast",
    desc: "Optimized to use minimal system resources while providing maximum protection. No slowdown, no battery drain.",
    points: ["Less than 2% CPU usage", "Minimal battery impact", "Small app footprint"]
  },
  {
    title: "Simple Interface",
    desc: "Clean, intuitive design that makes security management effortless. Clear alerts and actionable steps.",
    points: ["One-tap scan initiation", "Clear threat explanations", "Easy settings management"]
  },
  {
    title: "Privacy First",
    desc: "Your data stays yours. We don't collect, store, or transmit any personal information from your device.",
    points: ["No data collection", "Local threat detection", "Zero tracking"]
  },
  {
    title: "Advanced AI Detection",
    desc: "Powered by machine learning algorithms that adapt and learn to detect even the most sophisticated threats.",
    points: ["Behavioral analysis", "Zero-day threat detection", "Adaptive learning"]
  },
  {
    title: "24/7 Expert Support",
    desc: "Get help whenever you need it with our dedicated support team of security experts and technical specialists.",
    points: ["Live chat support", "Email assistance", "Knowledge base access"]
  }
];

export const TESTIMONIALS = [
  {
    name: "Sarah Mitchell",
    role: "Software Developer, Toronto",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&crop=face",
    text: "HuntHeal is exactly what I needed. As someone who works with sensitive client data, I can't afford security risks. The app runs silently in the background and I've never noticed any performance impact. Highly recommend!"
  },
  {
    name: "Mike Johnson",
    role: "IT Manager, Seattle",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
    text: "I've tried several antivirus apps and HuntHeal is by far the best. It's lightweight, doesn't drain my battery, and the interface is so clean. Found and removed malware that other apps missed!"
  },
  {
    name: "Lisa Chen",
    role: "Digital Marketing, Vancouver",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
    text: "The privacy-first approach is what sold me. I love that my data stays on my device. The app is so easy to use and gives me peace of mind knowing my phone is protected 24/7."
  }
];

export const PLANS = [
  {
    name: "Monthly Plan",
    price: "$6.73",
    period: "per month",
    features: [
      "Full antivirus protection",
      "Real-time scanning",
      "Privacy protection",
      "Performance optimization",
      "24/7 support"
    ],
    popular: false
  },
  {
    name: "Annual Plan",
    price: "$33.09",
    period: "per year (Save 59%)",
    features: [
      "Everything in Monthly",
      "Priority support",
      "Advanced threat detection",
      "Family plan (up to 5 devices)",
      "Early access to new features"
    ],
    popular: true
  }
];

export const FAQS = [
  {
    q: "How do I set up HuntHeal on my Android device?",
    a: "Setting up HuntHeal is simple! Download the app from the Google Play Store, open it, and follow the on-screen instructions. The app will guide you through the initial setup and perform your first scan automatically."
  },
  {
    q: "Which Android devices are compatible?",
    a: "HuntHeal works on all Android devices running Android 6.0 (Marshmallow) and above. This includes most devices released in the last 5+ years from Samsung, Google, OnePlus, and other major manufacturers."
  },
  {
    q: "How does the free trial work?",
    a: "Start your free trial with no credit card required. You'll get full access to all premium features for 7 days. If you love it, choose a plan to continue. If not, simply uninstall - no charges, no hassle."
  },
  {
    q: "What's included in the money-back guarantee?",
    a: "We offer a 30-day money-back guarantee on all paid plans. If you're not completely satisfied with HuntHeal, contact our support team within 30 days of purchase for a full refund. No questions asked."
  },
  {
    q: "How does HuntHeal protect my privacy?",
    a: "HuntHeal operates entirely on your device. We don't collect, store, or transmit any personal data. All scanning and threat detection happens locally, ensuring your privacy is never compromised."
  }
];

export const TRUST_BADGES = [
  "ISO 27001 Certified",
  "SOC 2 Type II",
  "GDPR Compliant",
  "AV-TEST Winner"
];
